import Devises from 'internal/constants/devises';
import { RootState } from 'internal/rootReducer';

export const selectCurrency = (state: RootState): Devises => state.appState.currency;
